import { pxToRem } from 'src/common/utils/fonts';

export const DEFAULT_BORDER_RADIUS = pxToRem(12);
